/*
 * Resolves the "Beløp innbetalt fra forsikring" input when registering an
 * insurance settlement decision on a krav-sale (saleOther.js).
 *
 * TICKET-01209: the old handler defaulted an empty field to 0, and 0 is a
 * REJECTION ("forsikringen dekket ingenting") that creates a full-amount
 * egenandelsfaktura with no undo. The register button therefore requires an
 * explicit, positive amount; 0 kr may only come from the dedicated rejection
 * button (rejectAll).
 */

export function resolveCoveredAmountInput({ rawValue, rejectAll, total }) {
    if (rejectAll) {
        return { ok: true, coveredAmount: 0 };
    }
    const trimmed = String(rawValue == null ? '' : rawValue).trim();
    if (trimmed === '') {
        return {
            ok: false,
            error: 'Fyll inn beløpet forsikringen dekket før du registrerer. Dekket forsikringen ingenting, bruk knappen "Forsikring dekket ingenting" under.',
        };
    }
    const coveredAmount = parseFloat(trimmed.replace(',', '.'));
    if (!Number.isFinite(coveredAmount) || coveredAmount < 0) {
        return { ok: false, error: 'Ugyldig beløp.' };
    }
    if (coveredAmount === 0) {
        return {
            ok: false,
            error: 'Beløpet er 0. Dekket forsikringen ingenting, bruk knappen "Forsikring dekket ingenting" under.',
        };
    }
    if (coveredAmount > total + 0.01) {
        return { ok: false, error: 'Beløpet er høyere enn totalen i kravet.' };
    }
    return { ok: true, coveredAmount };
}

export default { resolveCoveredAmountInput };
